/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'extension.charts.aggregateData': 'Agregar datos',
  'extension.charts.aggregateDataDescription':
    'Combina los valores en un solo punto de datos cuando varias filas presentan el mismo valor.',
  'extension.charts.category': 'Categoría',
  'extension.charts.customizeTab': 'Personalizar',
  'extension.charts.dataMissing.details': 'No podemos encontrar la tabla de origen de este gráfico en la página.',
  'extension.charts.dataMissing.title': 'No hay datos que mostrar',
  'extension.charts.dataTab': 'Datos',
  'extension.charts.defaultColumnName': 'Columna {0}',
  'extension.charts.defaultTitle': 'Gráfico sin título',
  'extension.charts.defaultYLabel': 'Eje sin título',
  'extension.charts.extensionTitle': 'Gráfico',
  'extension.charts.height': 'Altura del área del gráfico',
  'extension.charts.height.large': 'Más alta',
  'extension.charts.height.medium': 'Predeterminado',
  'extension.charts.height.small': 'Más corta',
  'extension.charts.horizontal.orientation.label': 'Horizontal',
  'extension.charts.insert.tooltip': 'Insertar gráfico',
  'extension.charts.legend': 'Leyenda',
  'extension.charts.legend.auto': 'Automático',
  'extension.charts.legend.bottom': 'Debajo',
  'extension.charts.legend.left': 'Izquierda',
  'extension.charts.legend.position': 'Posición de la leyenda',
  'extension.charts.legend.right': 'Derecha',
  'extension.charts.legend.show': 'Mostrar leyenda',
  'extension.charts.legend.top': 'Arriba',
  'extension.charts.options.label': 'Opciones de gráfico',
  'extension.charts.options.tooltip': 'Cambiar las opciones del gráfico',
  'extension.charts.orientation.label': 'Orientación',
  'extension.charts.seriesNames': 'Series de datos',
  'extension.charts.showPoints': 'Mostrar puntos de datos',
  'extension.charts.smoothLines': 'Líneas suaves',
  'extension.charts.style': 'Estilo',
  'extension.charts.title': 'Título',
  'extension.charts.type.bar': 'Barras',
  'extension.charts.type.fieldDescription': 'Tipo de gráfico',
  'extension.charts.type.line': 'Líneas',
  'extension.charts.type.pie': 'Circular',
  'extension.charts.userTitle': 'Título',
  'extension.charts.vertical.orientation.label': 'Vertical',
  'extension.charts.xAxis': 'Eje X',
  'extension.charts.xLabel': 'Etiqueta del eje X',
  'extension.charts.yLabel': 'Etiqueta del eje Y',
};
